import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon, type Chain } from 'wagmi/chains'

const NETWORK_CHAIN_ENTRIES: Array<{ patterns: string[]; chain: Chain }> = [
	{ patterns: ['ethereum', 'eth', 'erc20'], chain: mainnet },
	{ patterns: ['binance', 'bnb', 'bsc', 'bnb smart chain'], chain: bsc },
	{ patterns: ['polygon', 'matic'], chain: polygon },
	{ patterns: ['arbitrum'], chain: arbitrum },
	{ patterns: ['optimism'], chain: optimism },
	{ patterns: ['avalanche', 'avax'], chain: avalanche },
	{ patterns: ['base'], chain: base },
]

function normalizeNetwork(network: string): string {
	return network.trim().toLowerCase()
}

export function getChainForNetwork(network: string): Chain | undefined {
	const normalizedNetwork = normalizeNetwork(network)

	return NETWORK_CHAIN_ENTRIES.find((entry) => entry.patterns.some((pattern) => normalizedNetwork.includes(pattern)))?.chain
}

export function isEvmNetwork(network: string): boolean {
	return Boolean(getChainForNetwork(network))
}

export function isSolanaNetwork(network: string): boolean {
	const normalizedNetwork = normalizeNetwork(network)
	return normalizedNetwork.includes('solana') || normalizedNetwork === 'sol'
}

export const SUPPORTED_DEPOSIT_CHAINS = [mainnet, bsc, polygon, arbitrum, optimism, avalanche, base] as const
